// extracted by css-extract-rspack-plugin
export default {"chart-container":"s44X12f___chart-container","chartContainer":"s44X12f___chart-container"};